export default function AdminImagePickerModal({ images, onSelect, onClose }) {
  return (
    <div className="admin-crop-backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="admin-imgpick-box">
        <div className="admin-imgpick-header">
          <h4 className="admin-crop-title">이미지 선택</h4>
          <button type="button" className="admin-imgpick-close" onClick={onClose} aria-label="닫기">✕</button>
        </div>

        <div className="admin-imgpick-grid">
          {images.map((img, i) => (
            <button key={`${img.url}-${i}`} type="button" className="admin-imgpick-item" onClick={() => onSelect(img.url)}>
              <img src={img.url} alt={img.alt || ''} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
